import { render, staticRenderFns } from "./opcatHeader.vue?vue&type=template&id=6c7763a0&scoped=true&"
import script from "./opcatHeader.vue?vue&type=script&lang=js&"
export * from "./opcatHeader.vue?vue&type=script&lang=js&"
import style0 from "./opcatHeader.vue?vue&type=style&index=0&id=6c7763a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7763a0",
  null
  
)

export default component.exports